<template>
    <vx-card>
        <div slot="no-body">
          <img v-if="thumbnail" :src="thumbnail" alt="thumbnail-img" class="responsive card-img-top">
          <img v-else src="@/assets/images/default/training-thumbnail.png" alt="thumbnail-img" class="responsive card-img-top">
        </div>
        <h4 v-if="title" class="mb-4">{{ title }}</h4>
        <p v-if="description" class="text-grey mb-4">{{ description }}</p>
        <div  class="flex justify-between flex-wrap">
          <vs-button class="mb-2" type="border round" icon-pack="feather" icon="icon-edit-2"
                     v-if="enableEdit && $acl.check('admin')" @click="editTrainingElements">
              Edytuj
          </vs-button>
          <vs-button v-if="enableStart" class="mb-2" type="border round" @click="openTraining">Otwórz szkolenie</vs-button>
        </div>
    </vx-card>
</template>

<script>
export default {
  name: 'TrainingCard',
  props: {
    title: String,
    description: String,
    thumbnail: String,
    uuid: String,
    enableEdit: {
      type: Boolean,
      default: false,
    },
    enableStart: {
      type: Boolean,
      default: true,
    }
  },
  methods: {
    editTrainingElements () {
      this.$router.push({ name: 'trainings_single', params: { uuid: this.uuid }})
    },
    openTraining() {
      this.$router.push({ name: 'user_trainings_single', params: { uuid: this.uuid } })
    }
  },
}
</script>
